import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRect } from "@reach/rect";
import { Fragment, useRef } from "react";
import { extendCommonContentStylesheet } from "@devowl-wp/web-cookie-banner";
import { Portal } from "./portal.js";
import { Tooltip } from "./tooltip.js";
import { useStylesheet } from "../contexts/stylesheet.js";
/**
 * A portaled close icon creates a close icon rendered to a given container. This allows
 * you to put the close icon on the top right corner of an `overflow:hidden` container and
 * the tooltip gets rendered correctly.
 *
 * Attention: When using `renderInContainer` the close icon uses an expensive function to
 * observe the position within the container with https://reach.tech/rect/#userect-observe.
 * Only render the close icon when necessery!
 */ const CloseIcon = ({ width, color, tooltipText, framed, renderInContainer, tooltipAlways, onClick, thickness = 1 })=>{
    const { closeIcon: { framed: framedClass, closeIcon, notPortalIcon, portalIcon, portalPlaceholder } } = useStylesheet().extend(...extendCommonContentStylesheet);
    const ref = useRef();
    const rect = useRect(ref, {
        observe: !!renderInContainer
    });
    const style = closeIcon({
        color,
        width,
        thickness,
        ...rect?.y > 0 ? {
            rectX: rect.x,
            rectY: rect.y
        } : {}
    });
    const tooltip = /*#__PURE__*/ _jsx(Tooltip, {
        // Hide on screen readers as the dialog should be closed with "Escape"
        "aria-hidden": true,
        title: tooltipText,
        onClick: onClick,
        position: renderInContainer ? rect?.y > 50 ? "top-left" : "left" : "top-left",
        always: tooltipAlways,
        className: `${renderInContainer ? portalIcon : notPortalIcon} ${framed ? framedClass : ""}`,
        style: style,
        children: /*#__PURE__*/ _jsxs("span", {
            "aria-hidden": true,
            children: [
                /*#__PURE__*/ _jsx("span", {}),
                /*#__PURE__*/ _jsx("span", {})
            ]
        })
    });
    return renderInContainer ? /*#__PURE__*/ _jsxs(Fragment, {
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: portalPlaceholder,
                style: style,
                ref: ref
            }),
            rect?.y > 0 && /*#__PURE__*/ _jsx(Portal, {
                renderInContainer: renderInContainer,
                children: tooltip
            })
        ]
    }) : tooltip;
};
export { CloseIcon };
